<div class = "dialog-header-container d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center justify-content-start">
        <div >
            <i (click)="sideNav.returnPinShortCutDialog() ? removePinDialog() : pinDialog()" style="cursor: pointer;transform: rotate(310deg);" class="material-icons">push_pin</i>
        </div>
        <div style="padding : 0px 0px 0px 5px">
            <h2 mat-dialog-title class="margin-0">Keyboard Shortcuts</h2>
        </div>
    </div>
    <div>
        <button mat-icon-button mat-dialog-close (click) = "closeTrigger()"><mat-icon>close</mat-icon></button>
    </div>
</div>
<mat-divider style="margin: 0px 0px 10px 0px;"></mat-divider>
<mat-dialog-content class="p-4">
    <table>
        <tr>
          <th>Key</th>
          <th>Shortcut Value</th>  
        </tr>
        <!-- <tr> -->
            <h4 class = "margin-0">Insert</h4>
        <!-- </tr> -->
        <tr>
          <td>Agenda</td>
          <td>/ag</td>
        </tr>
        <tr>
            <td>SubAgenda</td>
            <td>/sg</td>
        </tr>
        <tr>
          <td>Note</td>
          <td>/nn</td>
        </tr>
        <tr>
          <td>Decision</td>
          <td>/dd</td>
        </tr>
        <tr>
          <td>Task</td>
          <td>/tt</td>
        </tr>
        <tr>
          <td>Date</td>
          <td>/date</td>
        </tr>
        <tr>
            <td>Duration</td>
            <td>/dur</td>
          </tr>
        <h4 class = "margin-0">Append</h4>
        <tr>
            <td>Agenda</td>
            <td>/agl</td>
        </tr>
        <tr>
            <td>Note</td>
            <td>/nnl</td>
        </tr>
        <tr>
            <td>Decision</td>
            <td>/ddl</td>
        </tr>
        <tr>
            <td>Task</td>
            <td>/ttl</td>
        </tr>
        <h4 class = "margin-0">
            Save as
        </h4>
        <tr>
            <td>Note</td>
            <td>ALT+1</td>
        </tr>
        <tr>
            <td>Decision</td>
            <td>ALT+2</td>
        </tr>
        <tr>
            <td>Task</td>
            <td>ALT+3</td>
        </tr>
        <h4 class = "margin-0">
            Save selected text as
        </h4>
        <tr>
            <td>Note</td>
            <td>ALT+N</td>
        </tr>
        <tr>
            <td>Decision</td>
            <td>ALT+D</td>
        </tr>
        <tr>
            <td>Task</td>
            <td>ALT+T</td>
        </tr>
      </table>
</mat-dialog-content>
